import functionsMixins from "@/mixins/page/functionsMixins";
import CurrentPageEntity from "@/model/entities/resource/entity/CurrentPageEntity";
import UserAuthEntity from "@/model/entities/resource/entity/UserAuthEntity";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {

    mixins: [functionsMixins],
    data() {
        return {
            currentPage: CurrentPageEntity,
            userAuth: UserAuthEntity,
            pageEmbeddableLoaded:false,
            mountAgain: false,
        }
    },
    methods:{

        onMountedDefault(userAuth){

            this.userAuth = userAuth

            //Chama o mountedContinued interno
            this.mountedContinued()
        },

        reload(){
            this.mountAgain = true

            setTimeout(()=>{
                this.mountAgain = false
            },200)

        },

        /*MONTAGEM SIMPLIFICADA Utilizado quando é necessário realizar a montagem para condicionar a exibição do formulário*/
        async getAssemble(path,type){
            await crudGeneral.getAssemble(path, type)
                .then(response => {

                    this.userAuth = response.data;
                    this.currentPage = this.userAuth.currentPage


                })
                .catch(error => {
                    console.log('Erro externo: ' + error)
                });
        }

    }

}